import React from 'react';
import ReactDOM from 'react-dom';
import StartPage from './StartPage';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<StartPage />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js